import {Component, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {sleep} from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-show-qr',
	templateUrl: './show-qr.component.html',
	styleUrls: ['./show-qr.component.scss']
})
export class ShowQrComponent implements OnInit {
	qrString: string;
	constructor(private modalCtrl: ModalController) {}

	ngOnInit() {}
	static async show(modal: ModalController, qrString: string): Promise<any> {
		const resultScan = await modal.create({
			component: ShowQrComponent,
			cssClass: 'qr-info-modal auto-height',
			componentProps: {
				qrString: qrString
			}
		});
		await resultScan.present();
		const result = await resultScan.onDidDismiss();
		await sleep(100);
		return result.data;
	}
}
